/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRuleDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRuleDetailTestIds = {
  autoAssignRuleDetailPage: "auto-assign-rule-detail-page",
  btnActivate: "btn-activate",
  btnDeactivate: "btn-deactivate",
  btnEdit: "btn-edit",
  btnImpactAnalysis: "btn-impact-analysis",
  btnTestRule: "btn-test-rule",
  btnViewAffected: "btn-view-affected",
  cardRuleDetails: "card-rule-details",
  cardTitleExecutionHistory: "card-title-execution-history",
  cardTitleRuleInformation: "card-title-rule-information",
  cardTitleTestResults: "card-title-test-results",
  cardTitleVersionHistory: "card-title-version-history",
  colAccessProfile: "col-access-profile",
  colAction: "col-action",
  colIdentity: "col-identity",
  colParty: "col-party",
  colResource: "col-resource",
  colSystem: "col-system",
  linkOpenRequest: "link-open-request",
  linkViewAllExecutions: "link-view-all-executions",
  openRequestBanner: "open-request-banner",
  sectionAccessProfiles: "section-access-profiles",
  sectionConditionExpression: "section-condition-expression",
  btnFilterAffected: (filter: string) => `btn-filter-affected-${filter}`,
  btnFilterAffectedPrefix: () => "btn-filter-affected-" as TestIdPrefix,
  executionErrorLink: (exec_id: string) => `execution-error-link-${exec_id}`,
  executionErrorLinkPrefix: () => "execution-error-link-" as TestIdPrefix,
  linkAccessProfile: (profile_accessProfile_id: string) => `link-access-profile-${profile_accessProfile_id}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkAffectedIdentity: (item_identityId: string) => `link-affected-identity-${item_identityId}`,
  linkAffectedIdentityPrefix: () => "link-affected-identity-" as TestIdPrefix,
  linkAffectedParty: (item_partyId: string) => `link-affected-party-${item_partyId}`,
  linkAffectedPartyPrefix: () => "link-affected-party-" as TestIdPrefix
} as const;
